
import { mapState } from "vuex";

export default {
  data() {
    return {
      statusData: [
        { label: "Ready", data: "ready_at" },
        { label: "Picked-Up", data: "dispatched_at" },
        { label: "Completed", data: "completed_at" }
      ]
    };
  },
  computed: {
    ...mapState("reciever", ["orderDetails"])
  },
  methods: {
    isActive(data) {
      return data && this.orderDetails[data];
    }
  }
};
